<template>
	<div>
		<app-navbar></app-navbar>
		<div class="w-100">
			<div class="container">
				<div class="news-header" style="display: flex;justify-content: space-between;">
					<section>{{ __DATA.last_docs }}</section>
          <section>

            <button class="rss btn-rsslink" v-b-modal.modal-prevent-closing>{{ __DATA.follow }}<img img src="../assets/img/rss-link.svg"></button>
          </section>
					<!-- <p p>Фильтр:</p>
					<div class="d-flex isprav" >
						<div class="d-flex">
							<div class="d-flex my-flex">
								<my-checkbox text="Опубликованные нормативные документы"></my-checkbox>
								<my-checkbox text="Норм. документы, находящиеся на стадии разработки"></my-checkbox>
							</div>
							<div class="d-flex my-flex">
								<my-checkbox text="Отмененные норм. документы" :checked="true"></my-checkbox>
								<my-checkbox text="Удаленные норм. документы" :checked="false"></my-checkbox>
							</div>
						</div>
						<div class="d-flex input">
							<input type="text" name=""  class="form-control search-input" placeholder="Фильтровать список...">
              <button  type="reset" class="reset-btn-filter"><img src="/img/shape-silver.svg"></button>
						</div>
					</div> -->
				</div>
				<div class="news-content">
					<!-- <div class="theader">
            <ul>
              <li>№</li>
              <li>Нормативный документ (55)</li>
              <li>Статус / Дата добавления</li>
            </ul>
          </div> -->

         <div class="doc-carousel-item" v-for="(item, index) in news" :key="index">
          <div class="header">
            <span> <span class="notification"><!-- {{ item }} --></span>{{ item.doc_index }} {{ item.doc_registry_number }}:{{ item.approved_year }} <span v-if="item.harmonization[0] != null"><span v-if="item.harmonization[0].uzdst_bool">({{ item.harmonization[0].name }}, {{ matching_level_name(item.harmonization[0].matching_level) }})</span></span></span><div><img src="../assets/img/clock-logo.svg">{{ __DATA.date_entered_action }}: <span>{{ item.comissioning_date.split("-").reverse().join(".") }}</span></div>
          </div>
          <p><router-link :to="{ name: 'post', params: { id: item.id }}">{{ item[`name_${locale}`] }}</router-link></p>
          <p v-if="locale == 'ru'">
            {{ item.short_description  }}
          </p>
          <p v-if="locale == 'uz'">
            {{ item.short_description_uz  }}
          </p>
        </div>
        
        <template v-if="page_count != 1">
          <paginate
            :page-count="page_count"
            :page-range="4"
            :margin-pages="2"
            :click-handler="clickCallback"
            :next-link-class="'next-class'"
            :prev-link-class="'prev-class'"
            :container-class="'vue-pagination'"
            :page-class="'vue-page-item'"
            :prev-text="`<img src=${require('../assets/img/pag-left.svg')}>`"
                :next-text="`<img src=${require('../assets/img/pag-right.svg')}>`">

            <span slot="prevContent"><span>asdj</span></span>
            <span slot="nextContent">Changed next button</span>
            <span slot="breakViewContent">
              <svg width="8" height="4" viewBox="0 0 16 4">
                <circle fill="#373737" cx="2" cy="2" r="2" />
                <circle fill="#373737" cx="8" cy="2" r="2" />
                <circle fill="#373737" cx="14" cy="2" r="2" />
              </svg>
            </span>
          
          </paginate>
        </template>

				</div>
			</div>
		</div>
		<app-footer></app-footer>
    <b-modal
        id="modal-prevent-closing"
        ref="modal"
        @ok="handleOk"
      >
      <section>
        {{ __DATA.f_in_news }} <span>{{ doc_category }}</span>
      </section>
      <template slot="modal-header" slot-scope="{ close }">
        <b-button  variant="outline-danger" class="modal-close-btn" @click="close()">
          <img src="../assets/img/modal-close.svg">
        </b-button>
      </template>
        <div class="form" ref="form">
        <p>{{ __DATA.your_main }}</p>
          <div class="form-group"> 
            <b-form-input
              id="name-input"
              v-model="email_adress"
              required
              type="email"
              @keyup.enter="follow()"
            ></b-form-input>
          </div>
          <button class="subs-btn" @click="follow()">
            {{ __DATA.follow }}
          </button>
        </div>
      </b-modal>

       
	</div>
</template>

<script type="text/javascript">
  import Vue from 'vue'
  import axios from 'axios'
import { API_HOST } from '../store'

  Vue.use(axios)
	export default {
		data () {
			return {
        email_adress: null,
				slip: null,
        rows: null,
        documents_count: null,
        documents: null,
        page: 1,
        page_count: 1,
        news: [],
        dic_matching_level: []
			}
		}, 
    mounted () {

      axios.get(API_HOST + '/api/dictionary/matching_level/')
      .then( (response) =>{
        this.dic_matching_level = response.data
      })
      .catch((error) => {
        console.log(error)
      })

      axios.get(API_HOST + '/api/slip/?ordering=-created_at&published=true&page=' + this.page)
      .then( (response) => {
        this.news = response.data.results
        response.data.results.map( e => {
          this.documents_count = response.data.count
          this.documents = response.data.results
          if(response.data.count > 10 ) {
              if(response.data.count/10 == parseInt(response.data.count/10)) {
                  this.page_count = parseInt(response.data.count/10)
              }
              else {
                  this.page_count = parseInt(response.data.count/10) + 1
              }
          }
          else {
            this.page_count = 1
          }

        })

      })
      .catch(error => {
          console.log(error)
        })
        .finally(() => {
          if(this.slip_data == 0){
            this.doc_length = 0;
            this.page_count = 1;
          }
        })
    },
    computed: {
      locale() {
        return this.$i18n.locale
      },
      __DATA() {
        return this.$i18n.messages[`${this.locale}`]
      }
    },
    methods: {

      follow () {
        axios.post(API_HOST + '/api/subscription/', {
          email: this.email_adress
        })
        .then((response) => {
          if(response.status == 201) {
            this.$swal.fire({
              icon: 'success',
              title: 'Подписка оформлена',
              text: 'Мы будем вам отпралять последние опубликованные НД на вашу почту'
            })
          }
        })
        .catch(error => {
          this.$swal.fire({
            icon: 'error',
            title: 'Подписка не оформлена',
            text: 'Введите корректный e-mail или подписка заранее было оформлена'
          })
        })
        .finally(() => {
          this.$refs.modal.hide()
        })
      },
      matching_level_name (id) {
        let c = null
        this.dic_matching_level.filter( resp => {
          if(id == resp.id) 
            c = resp.name
        })
        return c
      },
      clickCallback (val) {
        this.page = val
        axios.get(API_HOST + '/api/slip/?ordering=-created_at&published=true&page=' + this.page)
        .then( (response) => {
          this.news = response.data.results

            response.data.results.map( e => {
            this.documents_count = response.data.count
            this.documents = response.data.results
            if(response.data.count > 10 ) {
              if(response.data.count/10 == parseInt(response.data.count/10)) {
                  this.page_count = parseInt(response.data.count/10)
              }
              else {
                  this.page_count = parseInt(response.data.count/10) + 1
              }
            }
            else {
              this.page_count = 1
            }

          })
          
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          if(this.slip_data == 0){
            this.doc_length = 0;
            this.page_count = 1;
          }
        })
      }
    }
	}
</script>

<style type="text/css" lang="scss" scoped>
  .news-content {
    margin-bottom: 150px;
  }
  .doc-carousel-item {
    .notification {
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
      margin-right: 5px;
      color: #ED802C !important;
    }
    width: 100% !important;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    padding: 19.85px 31.83px;
    box-sizing: border-box;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    height: 141px;
    .header {
      margin-bottom: 5px;
      span {
        font-family: Open Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 15px;
        line-height: 20px;
        color: #333333;
      }
      div {
        float: right;
        display: flex;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        line-height: 16px;
        color: #AAAAAA;
        span {
          font-size: 12px;
          line-height: 16px;
          text-transform: uppercase;
          color: #5E5E5E;
          margin-left: 7px;
          font-family: Open Sans;
          font-style: italic;
          font-weight: 300;
          text-align: right;
        }
        img {
          margin-right: 8.77px;
        }
      }
    }
    p {
      font-size: 12px;
      color: #464C62;
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 15px;
      color: #333333;
      margin: 0;
      padding: 0;
      &:nth-child(2) {
        overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
      }
      &:nth-child(3) {
        margin-top: 20px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      & a {
        overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        text-decoration-line: underline;
        color: #296ACB;
      }
      & .iso {
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
        text-transform: uppercase;
        text-decoration-line: none;
      }
    }
    .btn-div {
      left: 0;
      bottom: 14.1px;
      width: 100%;
      display: flex;
      position: absolute;
      text-align: center;
    }
    .about {
      background: #FF6168;
      height: 24.8px;
      width: 92.9px;
      border: none;
      margin: 0 auto;
      outline: none;

      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 12px;
      color: #FFFFFF;
    }
  }
  .news-header {
    padding: 50px 0;
    padding-bottom: 0;
    .input {
      justify-content: flex-end;
      flex: 1;
    }
    section {
      font-family: Open Sans;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      text-transform: uppercase;
      color: #273878;
      margin-bottom: 40.77px;
    }
    p[p] {
      margin: 0;
      font-family: Open Sans;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      text-transform: uppercase;
      color: #273878;
      padding: 0;
      margin-bottom: 20px;
    }
    .my-flex {
      flex-direction: column;
      margin-right: 10.5px;
      max-width: 307px;
    }
  }
    @media (max-width: 635px) {
        .isprav {
            flex-direction: column;
            align-items: flex-start;
        }
    }
</style>